module.exports = __webpack_public_path__ + "img/6pm_logo.772a0e85.png";